import { UseTranslationResponse } from "react-i18next";

interface IResolveProductionPreviewCancelLabelArguments {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: UseTranslationResponse<any, any>["t"];
  isStarted: boolean;
  isFinished: boolean;
}

export const resolveProductionPreviewCancelLabel = ({
  t,
  isStarted,
  isFinished,
}: IResolveProductionPreviewCancelLabelArguments): string => {
  if (isStarted && !isFinished) {
    return t("rideProduction.abortProduceAndClose");
  }

  return t("general.CLOSE");
};
